export default "__VITE_ASSET__BAi6B9bq__"